import { defineStore } from 'pinia';
import { createServices } from '@/data/faker';
import { fetchServiceById } from '@/services/servicesService';

export const useServiceStore = defineStore('services', {
    state: () => ({
        services: [],
    }),
    actions: {
        loadServices(count = 50) {
            if (this.services.length === 0) {
                this.services = createServices(count);
            }
        },
        async getServiceById(id) {
            let service = this.services.find((c) => c.id === id);
            if (!service) {
                service = await fetchServiceById(id);
                if (service) this.services.push(service);
            }
            return service;
        },
        async updateService(updatedService) {
            const index = this.services.findIndex((c) => c.id === updatedService.id);
            if (index !== -1) this.services[index] = { ...updatedService };
        },
        async deleteService(id) {
            this.services = this.services.filter((c) => c.id !== id);
        },
    },
});
